import mixins from 'vue-typed-mixins';

import { Eフェーズ種別 } from '@/openapi/user';
import 法人保有 from '@/entries/user/pages/authorized/事業所/計画書/分析/保有不動産/法人保有/法人保有.vue';
import 個人保有 from '@/entries/user/pages/authorized/事業所/計画書/分析/保有不動産/個人保有/個人保有.vue';
import MoneyUnitSelect from '@/components/moneyUnitSelect/MoneyUnitSelect.vue';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import TabsMixin from '@/mixins/TabsMixin';

export default mixins(RoutesMixin, TabsMixin).extend({
  name: 'P保有不動産',

  components: {
    tab0: 法人保有,
    tab1: 個人保有,
    MoneyUnitSelect,
  },

  data(): {
    tabs: string[];
    eフェーズ種別: Eフェーズ種別;
  } {
    return {
      tabs: ['法人保有', '個人保有'],
      eフェーズ種別: Eフェーズ種別.分析フェーズ,
    };
  },
});
